import { ArtistEditorialPageDetailsFragment } from '@/gql/generated/graphql'
import { AllPurposeLink } from '@components/all-purpose-link'
import { BodyText, DetailText } from 'design-configuration/components'
import { ImageWithCustomLoader } from '@components/image-with-custom-loader'
import React from 'react'
import { trackButtonClicked, TrackedButtonNames } from '@utils/analytics'
import useMeasure from 'react-use-measure'

type ExhibitionsSectionProps = {
  artistInfo?: ArtistEditorialPageDetailsFragment | null
}

export const ExhibitionsSection = ({ artistInfo }: ExhibitionsSectionProps): React.ReactElement => {
  const [frameRef, frameBounds] = useMeasure()
  const frameWidth = frameBounds.width
  const frameHeight = frameWidth / 1.77

  return (
    <div className="md:gap-md gap-xl grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
      {artistInfo?.ExhibitionsSection?.exhibitionItem?.map((exhibition) => (
        <AllPurposeLink
          key={`exhibtion-${exhibition?.title}`}
          href={exhibition?.url ?? ''}
          onClick={() =>
            trackButtonClicked(TrackedButtonNames.artistExhibition, {
              artistPage: artistInfo,
              customProperties: {
                'Routed to exhibition full url': exhibition?.url,
                'Routed to exhibition title': exhibition?.title
              }
            })
          }
        >
          <div className="h-full w-full" ref={frameRef}>
            <div
              className="relative"
              style={{
                width: `${frameWidth}px`,
                height: `${frameHeight}px`
              }}
            >
              <ImageWithCustomLoader
                src={exhibition?.image?.data?.attributes?.url ?? ''}
                alt={`Exhibition photo for: ${exhibition?.title}`}
                fill
                style={{ objectFit: 'cover', objectPosition: 'center' }}
                sizes="100vw"
              />
            </div>
            <div className="mt-sm gap-y-2xs flex flex-col">
              <DetailText className="text-on-surface-variant">{exhibition?.subtitle?.toUpperCase()}</DetailText>
              <BodyText className="text-on-surface">{exhibition?.title}</BodyText>
            </div>
          </div>
        </AllPurposeLink>
      ))}
    </div>
  )
}
